<div class="chart-slide body" #innerBody>
    <!-- ============================================================
         PART 1 — Package offer/gap table. Rows are clickable and jump
         the carousel to the corresponding slide.
         ============================================================ -->
    @if (packageSlides != null && packageSlides.length > 0) {
    <div class="prices-stats-block mt-10">
        <table mat-table
               [dataSource]="packageSlides"
               class="offer-summmary-table in-card-table background-transparent">

            <ng-container matColumnDef="No">
                <th mat-header-cell *matHeaderCellDef style="text-align: left !important">#</th>
                <td class="f14" mat-cell *matCellDef="let slide">
                    {{slide.offerIndex + 1}}
                </td>
            </ng-container>

            <ng-container matColumnDef="Price">
                <th mat-header-cell *matHeaderCellDef style="text-align: left !important">$/kWh</th>
                <td class="f14" mat-cell *matCellDef="let slide">
                    {{slide.rowPrice | currency:'USD':'symbol':'1.5-5'}}
                </td>
            </ng-container>

            <ng-container matColumnDef="ServiceStart">
                <th mat-header-cell *matHeaderCellDef style="text-align: left !important">Service Start</th>
                <td class="f14" mat-cell *matCellDef="let slide">
                    {{slide.rowStart | date:'shortDate'}}
                </td>
            </ng-container>

            <ng-container matColumnDef="ServiceEnd">
                <th mat-header-cell *matHeaderCellDef style="text-align: left !important">Service End</th>
                <td class="f14" mat-cell *matCellDef="let slide">
                    {{slide.rowEnd | date:'shortDate'}}
                </td>
            </ng-container>

            <ng-container matColumnDef="Term">
                <th mat-header-cell *matHeaderCellDef style="text-align: left !important">Term</th>
                <td class="f14" mat-cell *matCellDef="let slide">
                    {{getTermText(slide)}}
                </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let slide; columns: displayedColumns; let i = index;"
                [ngClass]="i === currentPosition() ? 'current-slide-row' : ''"
                style="cursor: pointer;"
                (click)="gotoSlide(i)"></tr>
        </table>
    </div>
    }

    <!-- ============================================================
         PART 2 — Yellow tile. Fixed 70px height. Content driven by
         the current slide:
           * offer slide -> "Offer X of XXX" + "Save ..." built from
             selectedDatasets
           * gap slide   -> period only
         ============================================================ -->
    @if (hasHeader()) {
    <div class="price-info chat-info-shadow selected button mt-10" [style]="'background-color:'+getHeaderTileBackground()">
        <div class="caption">
            @if (getOfferPositionText() !== "") {
            <div class="f13 text-center" style="margin-top: -10px;">{{ getOfferPositionText() }}</div>
            }
            @if (isCurrentOffer()) {
            <span>
                {{getOfferSavingsMainText()}}
            </span>
            }
            @if (!isCurrentOffer()) {
            <span class="f16">{{getHeaderTermText()}}</span>
            }
        </div>
    </div>
    }

    <!-- ============================================================
         PART 3 — Chart slider. One slide per package entry.
           * offer slide -> chart
           * gap slide   -> chart-height placeholder with the message
         ============================================================ -->
    <div style="margin-top: -30px; z-index:1000; position: relative;">
        @if (sliderData != null && sliderData.length > 0) {
        <owl-carousel-o [class]="'offerSummarySlide mb-4 owl-theme'"
                        [options]="sliderOptions()" (changed)="sliderChange($event)" #slider>
            @for (sliderRecord of sliderData; track sliderRecord; let i = $index) {
            <ng-template carouselSlide [id]="i.toString()">
                <div class="item pb-4 custom-owl-item text-center">
                    <div>
                        <div class="block-buttons full-width">
                            <button (click)="gotoPackage()" class="selected">
                                Proceed with Package Offer
                            </button>
                        </div>
                    </div>
                    <div class="row">
                        @if (sliderRecord.activeRates.length > 0) {
                        <div class="chart-basis">
                            <kilowant-charts-home-accept-offer [view]="view()" [legend]="legend()" [legendTitle]="legendTitle()"
                                                               [legendPosition]="legendPosition()" [showGridLines]="true" [showDataLabel]="false"
                                                               [scheme]="colorScheme()" [showXAxisLabel]="showXAxisLabel()" [showYAxisLabel]="showYAxisLabel()"
                                                               [xAxis]="xAxis()" [yAxis]="yAxis()" [xAxisLabel]="xAxisLabel()" [yAxisLabel]="yAxisLabel()"
                                                               [groupPadding]="8" [barPadding]="4" [noBarWhenZero]="true"
                                                               [valLabel]="''"
                                                               [valColor]="getKilowantColor()"
                                                               [leftShift]="[]"
                                                               [rightShift]="[]"
                                                               [showNormalChatout]="false"
                                                               [shadow]="true"
                                                               [utilityAverageRate]="sliderRecord.utilityAveragePrice"
                                                               [communityAverageRate]="sliderRecord.communityAveragePrice"
                                                               [prefix]="i.toString()"
                                                               [results]="sliderRecord.activeRates"
                                                               [datasetSelector]="sliderRecord.countRates()>1"
                                                               [selectedDatasets]="selectedDatasets()"
                                                               [utilityWarningDate]="latestUtilityDate()"
                                                               [communityWarningDate]="latestCommunityDate()"
                                                               [tooltipDisabled]="true"
                                                               (datasetChanged)="changeDataset($event)">
                            </kilowant-charts-home-accept-offer>
                        </div>
                        }
                    </div>
                </div>
            </ng-template>
            }
        </owl-carousel-o>
        }
    </div>
</div>